import { render, staticRenderFns } from "./documentsUpload.vue?vue&type=template&id=5107c36a&scoped=true"
import script from "./documentsUpload.vue?vue&type=script&lang=js"
export * from "./documentsUpload.vue?vue&type=script&lang=js"
import style0 from "./documentsUpload.vue?vue&type=style&index=0&id=5107c36a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5107c36a",
  null
  
)

export default component.exports